import { useEffect, useState } from "react";
import axios from "axios";
import adminImage from "../../../assets/images/me.jpg";
import useUserProfile from "../../../customHooks/useUserProfile";
import Overview from "../../partials/application-portal/Overview";
import { applicationServiceAPI } from "../../../http/http";
import { toast } from "react-toastify";

function OverViewPage() {
  const [userProfile] = useUserProfile(); // Keep the original hook
  const user = JSON.parse(localStorage.getItem('user') ?? '{}');

  const [additionalData, setAdditionalData] = useState<any|null>(null); // For storing additional API data
  const [loading, setLoading] = useState(true); // Loading state for the new API call
  const [error, setError] = useState<string|null>(null); // Error state for the new API call

  useEffect(() => {
    const fetchAdditionalData = async () => {
      try {
        setLoading(true);
        const response = await applicationServiceAPI.get('/user/metrics');
        setAdditionalData(response.data.data.metrics);
      } catch (err: any) {
        console.error(err);
        toast.error(err.message ?? 'Failed to load metrics');
        setError('Failed to load metrics.');
      } finally {
        setLoading(false);
      }
    };

    fetchAdditionalData();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Show loading indicator while fetching additional data
  }

  if (error) {
    return <div>{error}</div>; // Display error message if the API call fails
  }

  return (
    <div className="">
      <Overview
        title={"BI OverviewPage"}
        description={`Hello ${user.firstName} ${user.lastName}!`}
        subtitle={"Glad to see you again."}
        userProfile={{
          name: user.firstName,
          imageUrl: user.profilePicture,
        }}
        metrics={[
          {
            adminImage: adminImage,
            label: "Mentor's Profile",
            name: "Simon K. Bankole",
            role: "Project Lead - Bi Erp",
            total: additionalData.total,
            approved: additionalData.approved,
            rejected: additionalData.rejected
          },
          {
            label: "Career Goal",
            goal: "No data to display",
          },
        ]}
        table={{
          columns: [
            { Header: "Name", accessor: "name" },
            { Header: "Mode", accessor: "mode" },
          ],
          data: [{ name: "BI Enterprise", mode: "Cashier" }],
        }}
      />
    </div>
  );
}

export default OverViewPage;
